import { render } from "./PhotoClassifyView.vue?vue&type=template&id=7f6c67c4&scoped=true"
import script from "./PhotoClassifyView.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyView.vue?vue&type=script&lang=js"

import "./PhotoClassifyView.vue?vue&type=style&index=0&id=7f6c67c4&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6c67c4"]])

export default __exports__